import AL from './logos/AL.png';
import EP from './logos/EP.png';
import ET from './logos/ET.png';
import FX from './logos/FX.png';
import HA from './logos/HA.png';
import SX from './logos/SX.png';
import ZA from './logos/ZA.png';
import ZD from './logos/ZD.png';
import ZE from './logos/ZE.png';
import ZI from './logos/ZI.png';
import ZL from './logos/ZL.png';
import ZR from './logos/ZR.png';
import ZT from './logos/ZT.png';
import ZU from './logos/ZU.png';
import unknown from './logos/unknown.jpg';

export default {
    AL,
    EP,
    ET,
    FX,
    HA,
    SX,
    ZA,
    ZD,
    ZE,
    ZI,
    ZL,
    ZR,
    ZT,
    ZU,
    unknown,
};




// WEBPACK FOOTER //
// ./src/app/modules/cars/assets/logos.js